<template>
<div class="container-fluid" id="businessRulesView">
  <h5 class="text-center mt-4 mb-4">{{ 'BUSINESS_RULES' | translate('nav') }}</h5>
  <div class="row" id="businessRulesView-row">
    <div class="col-5 col-lg-4" id="businessRulesView-col">
      <div class="text-right clearfix negative-margin-bot" id="businessRulesView-buttons">
        <button class="icon-button icon-button-collapsed btn btn-primary"
                v-tooltip="$options.filters.translate('RULES_GIT_SETTINGS_TITLE')"
                @click="showDroolsSettingsModal = true"
                id="businessRulesView-gitButton">
          <span class="btn-icon" id="businessRulesView-gitButton-span">
            <i class="fa fa-cog" aria-hidden="true" id="businessRulesView-gitButton-data"></i>
          </span>
        </button>
        <button class="icon-button icon-button-collapsed btn btn-success"
              v-tooltip="$options.filters.translate('RESET_KIE_CONTAINER')"
              @click="showConfirmDroolsReset = true"
              id="businessRulesView-resetButton">
          <span class="btn-icon" id="businessRulesView-resetButton-span">
            <i class="fa fa-refresh" aria-hidden="true" id="businessRulesView-resetButton-data"></i>
          </span>
        </button>
      </div>

      <rules-files-list :rule="currentRule ? currentRule.filename : null"
                        :refresh="needFilesListRefresh"
                        @select-file="selectRule"
                        @add-new-rule="addNewRule"
                        @remove-rule="hideAddNewRule"
                        @loading-files="needFilesListRefresh = false"
                        id="businessRulesView-addBusinessRule">
      </rules-files-list>
    </div>
    <div class="col" id="rulesFilesList-editArea">
      <div class="edit-area-container" id="rulesFilesList-editArea-container">
        <rules-edit-area :rule="currentRule"
                         :newRule="addingNewRule"
                         :loading="editSectionLoading"
                         @remove-new-rule="hideAddNewRule"
                         @refresh-files-list="setNeedFilesListRefresh"
                         @made-changes="editChangesPresent = true"
                         @reset-changes="editChangesPresent = false"
                         id="rulesFilesList-rulesEditArea">
        </rules-edit-area>
      </div>
    </div>
  </div>

  <vodal :show="showDroolsSettingsModal"
         :closeOnEsc="true"
         :closeOnClickMask="false"
         :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}"
         @hide="showDroolsSettingsModal = false">
    <rules-git-configurations @git-branch-changed="needFilesListRefresh = true; showDroolsSettingsModal = false">
    </rules-git-configurations>
  </vodal>

  <confirm-dialog :show="showConfirmForClearChanges"
                  :textLabel="'msg.SURE_UNSAVED_CHANGES_IN_RULE'"
                  @hide-dialog="showConfirmForClearChanges = false"
                  @confirm="loadSelectedRule">
  </confirm-dialog>
  <confirm-dialog :show="showConfirmForClearChangesOnNewRule"
                  :textLabel="'msg.SURE_UNSAVED_CHANGES_IN_RULE'"
                  @hide-dialog="showConfirmForClearChangesOnNewRule = false"
                  @confirm="showAddNewRule">
  </confirm-dialog>
  <confirm-dialog :show="showConfirmDroolsReset"
                  :textLabel="'msg.SURE_DROOLS_RESET'"
                  @hide-dialog="showConfirmDroolsReset = false"
                  @confirm="resetDrools">
  </confirm-dialog>
</div>
</template>

<script>
import RestService from '../../service/RestService.js';
import RulesFilesList from './rules/RulesFilesList';
import RulesEditArea from './rules/RulesEditArea';
import RulesGitConfigurations from './rules/RulesGitConfigurations';
import ConfirmDialog from '../dialog/ConfirmDialog';
import Vodal from 'vodal';

export default {
  components: { RulesFilesList, RulesEditArea, RulesGitConfigurations, ConfirmDialog, Vodal },
  data: function () {
    return {
      rest: this.initRestService(),
      addingNewRule: false,
      currentRule: null,
      editSectionLoading: false,
      needFilesListRefresh: false,
      editChangesPresent: false,
      showConfirmForClearChanges: false,
      showConfirmForClearChangesOnNewRule: false,
      lastSelectedRule: null,
      showConfirmDroolsReset: false,
      showDroolsSettingsModal: false
    }
  },
  methods: {
    initRestService: function() {
      return new RestService();
    },
    selectRule(filename) {
      this.lastSelectedRule = filename;
      if (this.editChangesPresent) {
        this.showConfirmForClearChanges = true;
      } else {
        this.loadSelectedRule();
      }
    },
    loadSelectedRule() {
      let filename = this.lastSelectedRule;
      this.showConfirmForClearChanges = false;
      this.editSectionLoading = true;
      this.currentRule = { filename: filename, content: '' };
      this.rest.getRuleFile(filename)
        .then((res) => {
          this.currentRule = res.data;
          this.editSectionLoading = false;
          this.addingNewRule = false;
        });
    },
    addNewRule() {
      if (this.editChangesPresent) {
        this.showConfirmForClearChangesOnNewRule = true;
      } else if (!this.addingNewRule) {
        this.showAddNewRule();
      }
    },
    showAddNewRule() {
      this.showConfirmForClearChangesOnNewRule = false;
      this.addingNewRule = true;
      this.currentRule = { filename: '', content: '' };
    },
    hideAddNewRule(deletingFilename) {
      if (!deletingFilename || (deletingFilename && deletingFilename === this.currentRule.filename)) {
        this.currentRule = null;
      }
      this.addingNewRule = false;
    },
    setNeedFilesListRefresh(savedFile) {
      this.needFilesListRefresh = true;
      this.addingNewRule = false;
      this.editChangesPresent = false;
      this.currentRule = savedFile || null;
    },
    resetDrools() {
      this.rest.resetDrools().then(
        () => {
          this.$notify({
            type: 'alert-success',
            text: this.$options.filters.translate('msg.DROOLS_RESET_SUCCESS')
          });
        }
      ).catch(
        (err) => {
          this.$notify({
            type: 'alert-danger',
            duration: -1,
            text: this.$options.filters.translate('msg.ERROR_DURING_OPERATION')
          });
          this.$log.error(err.response.data);
        }
      );
      this.showConfirmDroolsReset = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-area-container {
  position: relative;
  padding: 15px;
  min-height: 250px;
  border: 1px solid #dee2e6;
}
.negative-margin-bot {
  margin-bottom: -46px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/BusinessRulesView.vue